/**
 * The Databox nav page. Builds the product adapter and mounts the shared browser — every app
 * dependency lives in `@common/Databox`, so this file stays portable.
 */
import { DataboxProviders } from '@common/Databox/DataboxProviders';
import { Databox } from '@prophecy/shared-ui/components/Databox';
import { DataboxProvider } from '@prophecy/shared-ui/components/Databox/DataboxContext';
import { LoadingPane } from '@prophecy/shared-ui/components/Databox/styled';
import { theme } from '@prophecy/theme';
import styled from 'styled-components';

import { useCoreDataboxAdapter } from './useCoreDataboxAdapter';

/** The shell is `height: 100%` and cannot bound itself, so the page gives it a viewport to fill. */
const Page = styled.div`
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  padding: ${theme.spaces.x16};
  background: ${theme.colors.gray50};
`;

export function DataboxPage() {
  return (
    <DataboxProviders>
      <Page>
        <StandaloneDatabox />
      </Page>
    </DataboxProviders>
  );
}

/**
 * No `pipeline`: there is no canvas to drag onto and no tab strip to preview into, so the shell
 * offers neither — it learns that from the adapter's silence, not from a flag naming this page.
 */
function StandaloneDatabox() {
  const { adapter, ready, connectorSlider } = useCoreDataboxAdapter();

  // The controller loads Home once, on mount, and here that mount is also the first of
  // `OrchestrationAuthProvider` — so mounting early would spend it on an empty jwt.
  if (!ready) return <LoadingPane>Loading…</LoadingPane>;

  return (
    <>
      <DataboxProvider adapter={adapter}>
        <Databox />
      </DataboxProvider>
      {connectorSlider}
    </>
  );
}
